import { Trophy } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { useNavigate } from 'react-router-dom';

export const CTASection = () => {
  const navigate = useNavigate();
  
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-[#1A1F2C] via-[#2A3441] to-[#1A1F2C]">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 bg-gradient-to-r from-white/90 to-white/70 bg-clip-text text-transparent">
            Comienza el viaje financiero de tus hijos hoy
          </h2>
          <p className="text-white/80 text-lg mb-8 max-w-2xl mx-auto">
            Únete a miles de padres que están preparando a sus hijos para un futuro financiero exitoso
          </p>
          <Button
            size="lg"
            className="bg-[#22c55e] hover:bg-[#16a34a] text-white text-lg px-8 h-12"
            onClick={() => navigate('/register')}
          >
            Comenzar Ahora
            <Trophy className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};